import(/* webpackMode: "eager" */ "/codebuild/output/src2357269973/src/auction-chase-frontend/node_modules/next/dist/client/link.js");
